const swiper = new Swiper('.js-navigation-usps', {
    loop: true,
    effect: "fade",
    fadeEffect: { crossFade: true },
    slidesPerView: "auto",
    centeredSlides: true,
    autoplay: {
        delay: 3000,
    }
});

const openMegaClass = "navigation__mega--open"
const menu = document.querySelector(".navigation__menu");

const closeOpenMenus = () => {
   const openMegas = document.querySelectorAll(`.${openMegaClass}`);
   openMegas.forEach((item) => {
      item.classList.remove(openMegaClass);

      const icon = item.querySelector("span");
      if(icon.innerText == "-") {
         icon.innerText = "+";
      }
      
      item.removeEventListener("click", (event) => {
         event.stopPropagation();
      });
   })
}

const megaTriggers = document.querySelectorAll('.js-navigation-trigger-mega').forEach((item) => {
   item.addEventListener("click", (event) => {

      const icon = item.querySelector("span");
      icon.innerText = icon.innerText == "+" ? "-" : "+";

      if(!item.classList.contains(openMegaClass)) {
         document.body.classList.add("mega-open");
         event.preventDefault();
      } else {
         document.body.classList.remove("mega-open");
         closeOpenMenus();
         return;
      }

      closeOpenMenus();
      item.classList.add(openMegaClass);
      item.nextElementSibling.classList.add(openMegaClass);
   })
})

window.addEventListener("click", (event) => {
   if(!event.target.classList.contains(openMegaClass)) {
      if(event.target.nodeName === "A") return;
      document.body.classList.remove("mega-open");
      closeOpenMenus();
   }
})

const navtrigger = document.querySelector(".js-navigation-trigger-mobile");
if(navtrigger) {

   navtrigger.addEventListener("click", () => {
      document.body.classList.toggle("mobile-nav-open");
      navtrigger.classList.toggle("navigation__trigger--open");
      document.querySelector(".navigation__menu").classList.toggle("navigation__menu--open");
   })
}

const navigation = document.querySelector(".js-navigation");
let lastScroll = 0;

const checkScrollDirection = () => {
   const scroll = window.scrollY;
   if(scroll > lastScroll && scroll > 150) {
      navigation.classList.add("navigation--down");
   } else {
      navigation.classList.remove("navigation--down");
   }
   lastScroll = scroll;
}

window.addEventListener("scroll", () => {
   if(navigation) {

      if(window.scrollY > 0) {
         navigation.classList.add("navigation--scrolled");
         navigation.classList.contains("navigation--front") && navigation.classList.remove("navigation--transparent");
      } else {
         navigation.classList.remove("navigation--scrolled");
         navigation.classList.contains("navigation--front") && navigation.classList.add("navigation--transparent");
      }

      checkScrollDirection();
   }
})

